import { Noun, Verb } from 'common/debug/analytics-constants';
import Controller from 'controller';
import Keys from 'data/keys';
import Auth from 'db/auth';
import track from 'debug/track';
import trackUe from 'debug/trackUe';
import $ from 'jquery';
import Browser from 'lib/browser';
import Keyboard from 'lib/keyboard';
import Util from 'lib/util';
import ApiAjax from 'network/api-ajax';
import _ from 'underscore';
import SidebarState from 'view-models/sidebar-state';
import globalClickHandler from 'views/internal/global-click-handler';
import Alerts from 'views/lib/alerts';
import Dialog from 'views/lib/dialog';
import Layout from 'views/lib/layout';
import PopOver from 'views/lib/pop-over';
// We don't officially support any browser that doesn't have
// requestAnimationFrame. But... we had one very nice person
// write in who was using Opera for Linux (latest version was
// released in 2011, what). It doesn't hurt us to polyfill
// here, and if we don't then dinosaur people will just see
// a big blank Trello.
const injectRequestAnimationFramePolyfill = function() {
  let fns = {};
  let timeout = null;
  let animationFrameIndex = 0;

  const performEnqueuedFunctions = function() {
    for (const id of Object.keys(fns || {})) {
      const fn = fns[id];
      fn();
    }
    timeout = null;
    fns = {};
  };

  window.requestAnimationFrame = function(fn) {
    const id = animationFrameIndex++;
    if (timeout === null) {
      timeout = setTimeout(performEnqueuedFunctions);
    }
    fns[id] = fn;

    return id;
  };

  window.cancelAnimationFrame = function(id) {
    delete fns[id];
  };
};

export const domReady = () => {
  $(document).ready(function() {
    $('meta[name=apple-itunes-app]').attr(
      'content',
      `app-id=461504587, app-argument=${location.href}`,
    );

    if (!('requestAnimationFrame' in window)) {
      injectRequestAnimationFramePolyfill();
    }

    // Calculate window size and reposition popover

    window.orientationchange = () => Dialog.calcPos();

    Browser.detectCustomWebkitScrollbars();

    // Adds the dataTransfer property to jQuery so we can get HTML5 drag/drop file uploads to work
    $.event.props.push('dataTransfer');
    // Adds the detail property so we can get data attached to custom events
    $.event.props.push('detail');

    // Header tracking
    const trackClick = (selector, category, action, label) =>
      $(document).on('click', selector, function(e) {
        const args = (() => {
          const result = [];
          for (const v of [category, action, label]) {
            if (v) {
              if (_.isFunction(v)) {
                result.push(v.call(this, e));
              } else {
                result.push(v);
              }
            }
          }

          return result;
        })();

        return track(...Array.from(args || []));
      });

    trackClick('.js-home-via-logo', 'Header', 'Logo', 'Home');
    trackClick('.header-signup', 'Header', 'Sign Up');

    $(document).on(
      'click',
      '.js-resend-confirmation-email',
      _.throttle(() => {
        return ApiAjax({
          type: 'POST',
          url: '/resendValidate',
          data: {
            email: Auth.me().get('email'),
          },
          success() {
            return Alerts.flash('email sent', 'confirm');
          },
        });
      }, 60000),
    );

    $(document).on('click', function(e) {
      if ($(e.target).closest('.js-react-root').length) {
        return;
      }

      return globalClickHandler(e);
    });

    // Close all on esc

    $(document).on('keyup', function(e) {
      const key = Keyboard.getKey(e);
      if (key === Keys.Escape) {
        e.preventDefault();
        Controller.getCurrentBoard();

        if (SidebarState.getShowSidebar() && !SidebarState.getPinSidebar()) {
          trackUe(
            Noun.HEADER,
            Verb.CLOSES,
            Noun.BOARDS_MENU,
            '',
            '',
            'by pressing escape key',
          );
        }
        SidebarState.hideUnpinnedSidebar();

        if (Layout.isEditing()) {
          return Layout.cancelEdits();
        } else if ($('.new-comment').hasClass('focus')) {
          return $('.new-comment')
            .removeClass('focus')
            .find('textarea')
            .blur();
        } else {
          $('input').blur();

          return $('textarea').blur();
        }
      }
    });

    // Disallow dragging of anything that isn't a .ui-draggable,
    // so we don't accidentally trigger our drag/drop handlers
    $(document).on('dragstart', (e) => {
      return (
        $(e.target).closest('.ui-draggable, .js-draggable, [draggable="true"]')
          .length > 0
      );
    });

    // Track if they're using FluidApp
    if (window.fluid) {
      track('FluidApp');
    }
  });
};

export const initializeLayers = () => {
  PopOver.init();
  Dialog.init();

  // Close and cancel stuff
  let isMouseDownOnOverlay = false;
  const $windowOverlay = $('.window-overlay');

  // this is to prevent clicks from bubbling to the overlay (Trelp-977)
  $windowOverlay.on('mousedown', function(e) {
    isMouseDownOnOverlay = e.target === this;
  });

  $windowOverlay.click(function(e) {
    // Do not try to intercept right or middle buttons, see https://trello.com/c/ctIopcqw
    if (e.button > 0) {
      Util.stopPropagation(e);

      return;
    }

    // if one clicks inside a dummy a tag, stop propagating the event
    const $aTarget = $(e.target).closest('a');
    if ($aTarget.length > 0 && $aTarget.attr('href') === '#') {
      Util.stopPropagation(e);

      return;
    }

    // if it's the focus dummy, don't do anything
    if ($(e.target).is('a.focus-dummy') || $(e.target).hasClass('checkbox')) {
      return;
    }

    // otherwise hide the popover if visible
    if (PopOver.isVisible) {
      PopOver.hide();

      return;
    }

    // then check if the person is editing something or writing a comment
    if (Layout.isEditing() && isMouseDownOnOverlay) {
      Layout.cancelEdits();

      return;
    }

    // then check if they simply clicked somewhere on the actual window
    if (e.target !== $windowOverlay[0]) {
      return;
    }

    // Also don't intercept when the click wasn't started on the overlay
    if (!isMouseDownOnOverlay) {
      Util.stopPropagation(e);

      return;
    }

    // …now we know they clicked off the window and they aren't doing anything,
    // so we can close the dialog unless it's harder to close
    if (!Dialog.harderToClose) {
      Dialog.hide();
    }
  });
};



// WEBPACK FOOTER //
// ./app/scripts/views/chrome/doc-init.js